<template>
  <!-- 关于我们 -->
  <div class="container" style="background: #f8f8f8">
    <div class="main">

    <div class="privacyPolicy">
        <h3 style="text-align: center;">未来电视开放平台服务隐私政策</h3>
        <p class="text-right"><span>更新时间：2020年7月8日</span></p>
        <p>版本更新提示：</p>
        <p>感谢您使用未来电视开放平台产品及服务！本次未来电视有限公司（以下称“未来电视“或”“我们”）依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T 35273-2020）以及其他相关法律法规和技术规范更新了一些内容，其中主要包括如下内容：<b>制定了独立于《未来电视开放平台用户注册协议》的隐私政策；向您介绍了我们公司主体的基本信息以及向您告知了我们的联系通道与方式等内容。</b></p>
        <p><b>为了更好的保护您的个人信息，建议您仔细阅读更新后的《未来电视开放平台隐私政策》，尤其是以黑色加粗的条款。如您对本隐私政策条款有任何异议或疑问，您可通过本《未来电视开放平台隐私政策》第10条“联系我们”中公布的联系方式与我们沟通。</b></p>
        <h4 style="text-align: center;">《未来电视开放平台隐私政策》目录</h4>
        <p>1.引言</p>
        <p>2.关于我们</p>
        <p>3.名词解释</p>
        <p>4.我们如何收集和使用您的个人信息</p>
        <p>5.我们如何共享、转让、公开披露您的个人信息</p>
        <p>6.关于使用Cookie和同类技术</p>
        <p>7.我们对您个人信息的存储与保护</p>
        <p>8.您管理个人信息的权利</p>
        <p>9.我们对未成年人的保护</p>
        <p>10.联系我们</p>
        <p>11.本政策如何更新</p>
        <p>12.争议解决</p>
        <div class="title-text text-first">
            <h4>1、引言</h4>
            <p>本《未来电视开放平台隐私政策》（以下称“本隐私政策”）适用于未来电视提供的“未来电视开放平台”和“未来电视内容开放平台”软件及服务。</p>
            <p><b>请您在使用本产品和/或服务前，仔细阅读并充分理解本隐私政策的全部内容。一旦您使用或继续使用“未来电视开放平台”、“未来电视内容开放平台”产品/服务，即表示您同意我们按照本隐私政策使用和处理您的相关信息。</b></p>
            <p><b>我们可能会不时依据法律法规或业务调整对本隐私政策进行修订。当本隐私政策发生变更后，我们会在版本更新后通过在显著位置提示或推送通知、消息等形式向您展示变更后的内容。</b></p>
            <p><b>您需理解，只有在您确认并同意变更后的《未来电视开放平台隐私政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您亦有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，您将不能或不能继续使用“未来电视开放平台”、“未来电视内容开放平台”产品和服务，请您审慎考虑。</b></p>
        </div>
        <div class="title-text text-two">
            <h4>2、关于我们</h4>
            <p>“未来电视开放平台”、“未来电视内容开放平台”由未来电视有限公司（以下称“未来电视”）及其关联公司提供产品运营和服务。</p>
            <p>关联公司是指在现在、将来控制未来电视有限公司、受未来电视有限公司控制或与未来电视有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。</p>
            <p>我们的主要运营主体的基本信息如下：未来电视有限公司，成立于2010年3月24日，注册地址为天津自贸试验区（空港经济区）环河北路80号空港商务园东区5-1，2-501，常用办公地址为天津自贸试验区（空港经济区）环河北路80号空港商务园东区5-1，2-501。</p>
        </div>
        <div class="title-text text-three">
            <h4>3、名词解释</h4>
            <p>除非另有约定，本隐私政策中使用到的名词，通常仅具有以下定义：</p>
            <div class="text-leves">
                <p>3.1<b>个人信息</b>（出自于GB/T 35273-2020《信息安全技术个人信息安全规范》）：<b>是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括自然人的基本资料（包括姓名、生日、性别、住址、电话号码、电子邮箱）、个人身份信息（包括身份证件号码）、个人生物识别信息（包括指纹、面部特征）、网络身份标识信息（包括系统账号、IP地址、邮箱地址以及与前述有关的密码、口令、口令保护答案）、个人财产信息（包括银行账号、口令、交易和消费记录、虚拟货币、虚拟交易、兑换码等虚拟财产信息）、通讯录信息、个人上网记录（包括网站浏览记录、软件使用记录）、个人常用设备信息（包括硬件序列号、硬件幸好、设备MAC地址、操作系统类型、软件列表、唯一设备标识符）、个人位置信息（包括大概地理位置、精确定位信息）。我们实际具体收集的个人信息种类以下文描述为准。</b></p>
                <p>3.2<b>个人敏感信息</b>（出自于GB/T 35273-2020《信息安全技术个人信息安全规范》）：<b>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中涉及的个人敏感信息包括您的个人财产信息、个人身份信息（包括身份证件号码）、个人生物识别信息、网络身份标识信息、通讯录信息、精准定位信息、收货地址。我们实际具体收集的个人敏感信息种类以下文描述为准。</b></p>
                <p>3.3<b>设备</b>：设备是指可用于访问我们的产品和/或服务的装置，例如台式计算机、笔记本电脑、平板电脑、智能手机、互联网电视终端等。</p>
                <p>3.4<b>唯一设备标识符</b>：唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的 IMEI 号）。唯一设备标识符有多种用途，其中可在不能使用 Cookie（例如在移动应用程序中）时用以提供广告。</p>
                <p>3.5<b>IP 地址</b>：每台上网的设备都会指定一个编号，称为互联网协议 ( IP ) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。</p>
                <p>3.6<b>SSL</b>：SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL 支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。</p>
                <p>3.7<b>Cookie</b>：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web Beacon、Proxy、嵌入式脚本等。</p>
                <p>3.8<b>帐号</b>：只要注册帐号并向我们提供一些个人信息，您就可以使用我们的服务。当您访问“XXXX“时，系统会利用这些帐号信息对您进行身份验证，以防止未经授权的人员访问您的帐号。</p>
                <p>3.9<b>去标识化/匿名化</b>：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体，且处理后的信息不能被复原的过程。</p>
                <p>3.10<b>服务器日志</b>：通常情况下，我们的服务器会自动记录您在访问网站时所发出的网页请求。这些“服务器日志”通常包括您的网络请求、互联网协议地址、浏览器类型、浏览器语言、请求的日期和时间及可以唯一识别您的浏览器的一个或多个 Cookie。</p>
            </div>
        </div>
        <div class="title-text text-four">
            <h4>4.我们如何收集和使用您的个人信息</h4>
            <p>未来电视依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品和/或服务需要而产生的个人信息。如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。</p>
            <p>我们收集和使用的您的个人信息类型包括两种：<b>第一种：我们产品与/或服务的核心业务功能所必需的信息：此类信息为产品与/或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品与/或服务；第二种：附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。</b></p>
            <p><b>您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，包括技术，这意味着我们可能会经常推出新的业务功能，可能需要收集新的个人信息或变更个人信息使用目的或方式。如果某一需要收集您的个人信息的功能或产品/服务未能在本隐私政策中予以说明的，我们会通过更新本政策、页面提示等方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。</b>在此过程中，如果您对相关事宜有任何疑惑的，可以通过文末提供的方式联系我们，我们会尽快为您作出解答。</p>
            <p>通常情况下，我们会在以下场景中收集和使用您的个人信息：</p>
            <p>4.1帐号注册</p>
            <div class="text-leves">
                <p><b>(1)您注册并登录未来电视开放平台帐号时，需要按照我们的指引完成一系列注册程序，在此过程中，您需要向我们提供以下信息：帐号昵称、手机号码（个人敏感信息，用于接受验证码匹配个人身份）。您只有提供真实准确的上述信息，才能成功注册未来电视开放平台帐号并使用产品和/或服务的核心功能。如果您选择不提供上述为实现未来电视开放平台核心产品功能的必备信息，或将导致我们无法为您提供该核心产品功能。</b></p>
                <p><b>(2)同时，您需理解，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法注册账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。</b></p>
            </div>
            <p>4.2 搜索功能</p>
            <p>当您在我们的产品中使用搜索功能时，我们需要收集您的一些信息，其中包括如下个人信息：您搜索的字或词、您的浏览记录和时间、您搜索的时间以及次数。我们收集这些信息是为了向您快速匹配您所需要的内容以及您可能感兴趣的内容，同时亦为了改进我们的产品和服务。</p>
            <p>4.3 视频展示和播放功能</p>
            <p><b>我们的产品和/或服务为您提供视频展示和播放服务，在此过程中，我们需要收集您的一些信息，包括如下个人信息：设备型号、设备名称、设备唯一标识符、设备分辨率、CPU、GPU、登录IP地址、产品版本号、操作系统、接入网络的方式、网络权限、网络状态、设备状态、Wi-Fi状态、网络信息（含运营商名称）、网络日志信息（如操作日志、服务日志）。同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供视频展示和播放服务，如您拒绝提供上述权限将可能导致您无法使用我们的相关产品与服务。</b></p>
            <p>4.4 客户服务功能</p>
            <p>当您向未来电视开放平台发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。<b>同时，为了方便与您联系或帮助您解决问题，我们可能还需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。</b></p>
            <p>4.5 支付功能</p>
            <p><b>当您在未来电视开放平台上开通会员服务时，需要使用到支付功能。在支付过程中， 我们可能会收集您的第三方支付渠道的user ID (例如微信open ID、QQ钱包open ID或银行卡信息)（个人敏感信息）。上述信息为我们向您提供您购买商品和/或服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。</b></p>
            <p>4.6 从第三方间接收集的您的个人信息</p>
            <div>
                <p>（1）您理解，您知悉，您向外部第三方（未来电视旗下关联公司不在此限）提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式擅自以软件程序获得您的个人信息。未来电视可能因业务发展的需要而确实需要从第三方间接收集（如共享等）您的个人信息的，且由我们直接或共同为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得您的授权同意）。我们的某些产品或服务由第三方业务合作伙伴提供或共同提供时，为了必要且合理的开展业务，我们可能会从部分业务合作伙伴处间接收集的您的部分信息。</p>
                <p>（2）我们的专业安全团队对个人信息将进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
            </div>
            <p>4.7 出于其他合理且必要的目的</p>
            <div class="text-leves">
                <p><b>（1）如前文所述，如果某一需要收集您的个人信息的功能或产品/服务未能在本隐私政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们将在收集和使用你的个人信息前，通过更新本隐私政策、页面提示、弹窗或其他便于您获知的方式另行向您说明，并为您提供自主选择同意的方式，且在征得您明示同意后收集和使用。</b></p>
                <p><b>（2）您理解并同意，在以下情况下，我们无需取得您的授权同意即可收集和使用您的个人信息：</b></p>
                <div class="text-leves" style="padding-left:32px;">
                    <p>a)与国家安全、国防安全有关的；</p>
                    <p>b)与公共安全、公共卫生、重大公共利益有关的；</p>
                    <p>c)与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
                    <p>d)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
                    <p>e)所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
                    <p>f)根据与您签订和履行相关协议或其他书面文件所必需的；</p>
                    <p>g)用于维护我们的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
                    <p>h)有权机关的要求、法律法规等规定的其他情形。</p>
                </div>
            </div>
        </div>
        <div class="title-text text-five">
            <h4>5、我们如何共享、转让、公开披露您的个人信息</h4>
            <p>5.1 共享</p>
            <p>我们重视对您的个人信息的保护，您的个人信息是我们为您提供产品与/或服务的重要依据和组成部分，对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。通常情况下，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
            <div class="text-leves">
                <p>（1)事先已获得您的明确授权或同意；</p>
                <p>（2)根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；</p>
                <p>（3）在法律要求或允许的范围内，为了保护未来电视及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；</p>
                <p>（4)您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享亦受本隐私政策声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；</p>
                <p>（5)为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。 如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方服务。通常我们的合作伙伴有如下几类：</p>
                <div class="text-leves" style="padding-left:32px;">
                    <p>a)为我们的产品与/或服务提供功能支持的服务提供商：例如提供支付服务的支付机构及其他服务提供商，我们共享信息的目的仅为实现我们产品与/或服务的功能；</p>
                    <p><b>b)第三方SDK类服务商：我们的产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）。如您使用支付宝付款的，为了让您完成交易、实现交易目的，支付宝SDK需要读取您的设备信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。</b></p>
                </div>
            </div>
            <p>5.2 转让</p>
            <p>除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束。如果本隐私政策中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。</p>
            <p>5.3 公开披露</p>
            <div class="text-leves">
                <p>（1）公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再公开披露，但法律法规另有规定的或本政策另有约定的除外。</p>
                <p>（2）对于公开披露的您的个人信息，我们会在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取最严格个人信息安全保护措施和手段对其进行保护。</p>
            </div>
            <p>5.4 共享、转让、公开披露您的个人信息的例外</p>
            <p><b>请您知悉， 根据法律法规的规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</b></p>
            <div class="text-leves" style="font-weight: bold;">
                <p>（1）与国家安全、国防安全直接相关的；</p>
                <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
                <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；</p>
                <p>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
                <p>（5）个人信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
                <p>（6）根据与您签订和履行相关协议或其他书面文件所必需的；</p>
                <p>（7）法律法规等规定的其他情形。</p>
            </div>
        </div>
        <div class="title-text text-six">
            <h4>6.关于使用Cookie和同类技术</h4>
            <p>（1）在您使用我们的产品与/或服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，包括：您访问网站的习惯、您的浏览信息、您的登录信息，Cookie和同类技术收集该类信息是为了您使用我们的产品与/或服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史（如视频观看历史）、向您提供更切合您个人需要的服务内容和您可能更感兴趣的内容、保护您的信息和账号安全性、提升我们的产品和服务等。</p>
            <p>（2）如果您拒绝我们使用Cookie及同类技术收集和使用您的相关信息，你可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、（部分/全部）拒绝Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。<b>您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品与/或服务或无法通过我们的产品与/或服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</b></p>
        </div>
        <div class="title-text text-seven">
            <h4>7.我们对您个人信息的存储与保护</h4>
            <p>7.1信息存储</p>
            <div class="text-leves" style="font-weight:bold;">
                <p>（1）存储地点：我们依照法律法规的规定，仅会将收集到的有关您的个人信息存储于中华人民共和国境内。 目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如果确有必要进行数据的跨境传输，我们会单独向您明确告知（包括数据出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等），并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</p>
                <p>（2）存储期限：我们在为您提供满足产品和服务目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册及会员功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续保存您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。此外，我们或对您的相关信息保存至相关法律所规定的必要期限（例如《网络安全法》第二十一条规定，“采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。”）。在超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。</p>
            </div>
            <p>7.2 信息保护</p>
            <p>您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。</p>
            <div class="text-leves">
                <p><b>（1）我们使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如使用SSL对数据进行加密保护；我们已建立访问控制机制，确保只有授权人员才可以访问个人信息；我们不时的举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</b></p>
                <p>（2）为防止安全事故的发生，我们成立了专门的数据安全部门并制定了妥善的预警机制和应急预案。一旦发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时将事件相关情况以电话、推送通知等方式告知您。</p>
            </div>
        </div>
        <div class="title-text text-eight">
            <h4>8.您管理个人信息的权利</h4>
            <p>我们理解您对个人信息的关注，并尽全力确保您对于自己个人信息访问、更正、删除以及撤回授权的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
            <p>8.1 您有权访问您的个人信息</p>
            <p>您可以按照我们提供的产品和服务的相关说明（或设置），对您已提供给我们的相关个人信息进行查阅。包括：</p>
            <div class="text-leves">
                <p>（1）账号信息：您可以通过相关产品页面随时登陆您的个人中心，以访问您账号中的个人资料信息，包括：头像、昵称、UID等；</p>
                <p>（2）使用信息：您可以通过相关产品页面随时查阅您的使用信息，包括：收藏记录、历史记录、追番等；</p>
                <p>（3）其他信息：如您在访问过程中遇到操作问题的活如需获取其他前述无法获知的个人信息内容，您可通过本隐私政策提供的方式联系我们。</p>
            </div>
            <p>8.2 您有权更正/修改您的个人信息</p>
            <p>当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，经过对您身份的验证，且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，或在特定情况下，尤其是数据错误时，通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。</p>
            <p>8.3 您有权删除您的个人信息</p>
            <p>对于您的部分个人信息，您也可以自行通过我们提供的相关产品和服务的功能页面，主动删除您提供信息。例如：您可在产品页面主动删除您的搜索记录。一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。</p>
            <p>当发生以下情况时，您可以直接要求我们删除您的个人信息，但已做匿名化处理或法律法规另有规定的除外：</p>
            <div class="text-leves">
                <p>（1）当我们处理个人信息的行为违反法律法规时；</p>
                <p>（2）当我们收集、使用您的个人信息，却未征得您的同意时；</p>
                <p>（3）当我们处理个人信息的行为违反了与您的约定时；</p>
                <p>（4）当您注销了帐号时；</p>
                <p>（5）当我们终止服务及运营时。</p>
            </div>
            <p>如果您在处置您的个人信息时有任何疑问，您可以通过本隐私政策第10条“联系我们”中公示的联系方式与我们沟通解决。</p>
        </div>
        <div class="title-text text-nine">
            <h4>9.我们对未成年人的保护</h4>
            <p>9.1 未成年人使用我们的产品与/或服务前应取得其监护人的同意。<b>如您为未成年人，在使用我们的产品与/或服务前，应在监护人监护、指导下共同阅读本隐私政策且应在监护人明确同意和指导下使用我们的产品与/或服务、提交个人信息。我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息。</b></p>
            <p>9.2 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，您可以通过本隐私政策第10条“联系我们”中公示的联系方式与我们沟通解决。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会尽快删除相关数据。</p>
        </div>
        <div class="title-text text-ten">
            <h4>10.联系我们</h4>
            <p>10.1如您对本《未来电视开放平台隐私政策》的内容或使用我们的服务时遇到的与隐私保护相关的事宜有任何疑问或进行咨询或投诉时，您均可以通过如下任一方式与我们取得联系： </p>
            <div class="text-leves">
                <p>（1）您可找到我们平台上产品功能页面中在线客服与其联系或者在线提交反馈意见；</p>
                <p>（2）您可以拨打4000463366客服电话与我们联系；</p>
                <p>（3）您可以添加QQ:800085092与我们联系；</p>
                <p>（4）您可以向我们开通的service@chinaott.net客服邮箱发送邮件与我们联系；</p>
            </div>
            <p>10.2 我们会在收到您的意见及建议后，并在验证您的用户身份后的30日内尽快向您回复。此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</p>
            <div class="text-leves">
                <p>（1）与国家安全、国防安全有关的；</p>
                <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
                <p>（3）与犯罪侦查、起诉和审判等有关的；</p>
                <p>（4）有充分证据表明您存在主观恶意或滥用权利的；</p>
                <p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
                <p>（6）涉及商业秘密的；</p>
                <p>（7）法律法规等规定的其他情形。</p>
            </div>
        </div>
        <div class="title-text text-eleven">
            <h4>11.本政策如何更新</h4>
            <p>11.1 为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本隐私政策的条款，该等更新构成本隐私政策的一部分。未经您明确同意，我们不会削减您按照本政策所应享有的权利。如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的隐私政策的约束。</p>
            <p>11.2 重大变更包括但不限于：</p>
            <div class="text-leves">
                <p>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
                <p>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
                <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
                <p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
                <p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
                <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
            </div>
        </div>
        <div class="text-twelve">
            <h4>12. 争议解决</h4>
            <p>12.1 本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向天津市滨海新区人民法院提起诉讼解决。</p>
            <p>12.2 如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。</p>
            <p>12.3本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。</p>
        </div>
        <p class="text-right"><span>未来电视有限公司</span></p>
    </div>
    </div>
    <!-- 底部链接加版权信息 -->
    <div class="footer">
      <div class="footer-content">
        <img class="logo" :src="logo" alt="" />
        <div style="text-align: center">
          <p class="breadcrumb">
            <span class="spanWord" @click="sy">网站首页</span>
            <span>|</span>
            <span class="spanWord" @click="handleUs">关于我们</span>
            <span>|</span>
            <span class="spanWord" @click="handleUser">用户协议</span>
            <span>|</span>
            <span class="spanWord" @click="handlePrivacy">隐私协议</span>
            <span>|</span>
            <span class="spanWord" @click="handleContact">联系我们</span>
          </p>
          <div class="rightCopy">
            <p>广播电视节目制作经营许可证：（津）字第379号</p>
            <p>网络文化经营许可证：津网文[2016]1209-018号</p>
            <p>津ICP备12004891号</p>
          </div>
        </div>
        <img class="cord" :src="cord" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/home1-image/logo.png'
import cord from '@/assets/home1-image/cord.png'
import banner from '@/assets/home1-image/banner.png'
export default {
  name: 'privacyPolicy',
  data () {
    return {
      logo: logo,
      cord: cord,
      defaultImg: banner
    }
  },
  mounted () {},
  methods: {
    sy () {
      this.$router.replace('/')
    },
    handleUs () {
      this.$router.replace('/aboutUs')
    },
    handleUser () {
      this.$router.replace('/useragreement')
    },
    handlePrivacy () {
      this.$router.replace('/privacyPolicy')
    },
    handleContact () {
      this.$router.replace('/contactUs')
    }
  }
}
</script>

<style scoped lang="less">
@import "index";
</style>
